import NextSectionAction from "components/next-section-action";
import OrderToChaos from "components/views/features/order-to-chaos";
import dynamic from "next/dynamic";

import Page from "../../components/layout/page";
import CoreFeatures from "../../components/views/features/core-features";
import CustomerEngagement from "../../components/views/features/customer-engagement";
import Docflo from "../../components/views/features/docflo";
import Lendflo from "../../components/views/features/lendflo";
import MainHero from "../../components/views/features/main-hero";
import PlatformBenefits from "../../components/views/features/platform-benefits";
import ProjectManagement from "../../components/views/features/project-management";
import SalesProcess from "../../components/views/features/sales-process";

import type { NextPage } from "next";
const DemoFormSection = dynamic(() => import("../../components/demo-form-section"));

const Features: NextPage = () => {
  return (
    <Page
      title="Enerflo Solar Software Platform | Features & Benefits"
      description="Enerflo combines the features solar dealers and installers need into one unified platform, including sales, project management, doc signing, financing and more."
    >
      <MainHero />
      <OrderToChaos />
      <PlatformBenefits />
      <CoreFeatures />
      <SalesProcess />
      <ProjectManagement />
      <CustomerEngagement />
      <Docflo />
      <Lendflo />
      <NextSectionAction
        buttonText="View Sales Process"
        url="/features/sales-process"
        description="See how Enerflo can simplify your Sales Process"
      />
      <DemoFormSection />
    </Page>
  );
};

export default Features;
